import { render, staticRenderFns } from "./ReceptionRooms.vue?vue&type=template&id=cfea2372"
import script from "./ReceptionRooms.vue?vue&type=script&lang=js"
export * from "./ReceptionRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports